<div class="flex-horizontal">
  <div class="stepper flex-vertical gap-56 background-white">
    <div class="flex-vertical">
      <h5>{{ stepperTitle }}</h5>
      <ng-container *ngIf="currentFicheConseil">
        <div class="body-1 color-on-surface-medium">{{ operationTypeLabel }} - {{ enveloppeLabel }}</div>
        <div class="body-1 color-on-surface-medium">{{ InvestisseurTypeLabel }}</div>
      </ng-container>
    </div>
    <oui-stepper [steps]="steps" [displayNumbers]="false" direction="vertical" #stepper></oui-stepper>
    <div class="flex-1"></div>
    <oui-banner
      title="Sans mise à jour, cette fiche conseil sera supprimée dans un délai de {{
        ficheConseilSuppressionDelay
      }} jours, quel que soit son statut."
      [showCloseButton]="false"></oui-banner>
  </div>
  <div class="content">
    <div *ngIf="isLoading; else dataLoaded">
      <oui-loading class="loadingCenterItem"></oui-loading>
    </div>

    <ng-template #dataLoaded>
      <div class="flex-horizontal">
        <div class="flex-1"></div>
        <div class="flex-vertical gap-32 width-100pc max-width-1024">
          <h4>
            {{ this.stepper?.currentStep?.title }}
          </h4>
          <ng-container *ngIf="this.stepper?.stepIndex === 0 && this.stepper?.currentStep?.title == stepEnum.CONTRAT">
            <app-contrat-step
              class="width-100pc max-width-1024"
              (onContratSelection)="onContratSelected($event)"
              [contratId]="ficheConseilService.currentFicheConseilSubject.value?.contratId"
              [isModifierDisabled]="
                !!ficheConseilService.currentFicheConseilSubject.value?.investisseur?.situationPersonnelle
              "
              #contratStepComponent>
            </app-contrat-step>
          </ng-container>

          <ng-container *ngIf="this.stepper?.stepIndex === 0 && stepper?.currentStep?.title !== stepEnum.CONTRAT">
            <app-investisseur-step
              title="{{ this.steps[0].title }}"
              class="width-100pc max-width-1024"
              #investisseurStepComponent></app-investisseur-step>
          </ng-container>
          <ng-container *ngIf="this.stepper?.stepIndex === 1">
            <app-step-connaissance-client
              #stepConnaissanceClientComponent
              [title]="this.steps[1].title"
              class="width-100pc max-width-1024"></app-step-connaissance-client>
          </ng-container>
          <ng-container *ngIf="this.stepper?.stepIndex === 2">
            <app-exigences-step
              title="{{ this.steps[2].title }}"
              class="width-100pc max-width-1024"
              #exigencesStepComponent></app-exigences-step>
          </ng-container>
          <ng-container *ngIf="this.stepper?.stepIndex === 3">
            <app-projet-investissement
              title="{{ this.steps[3].title }}"
              class="width-100pc max-width-1024"
              #projetInvestissementComponent></app-projet-investissement>
          </ng-container>
          <ng-container *ngIf="this.stepper?.stepIndex === 4">
            <app-precision-complementaire-step
              title="{{ this.steps[4].title }}"
              class="width-100pc max-width-1024"
              #precisionComplementaireStep></app-precision-complementaire-step>
          </ng-container>
        </div>
        <div class="flex-1"></div>
      </div>
    </ng-template>
  </div>
</div>
<lib-stepper-footer
  [isNextStepDisabled]="false"
  [previousStepButtonText]="previousLabel"
  [nextStepButtonText]="ctaLabel"
  [nextStepButtonIcon]="isLastStep"
  (nextStepClicked)="onNextStepClick()"
  (previousStepClicked)="onPreviousStepClick()"
  (saveAndExitClicked)="onSaveAndExitClik()"
  [nextStepFullActive]="nextStepButtonActivity()"
  [nextStepWithArrow]="!isLastStep"></lib-stepper-footer>
